import type { ThreadFilter } from "@/__generated__/graphql";

/**
 * Server filter behind each thread-list tab. The list opens on ``all``, which
 * is also the page ``ThreadTabBar`` preloads while its list toggle is hovered.
 * ``all`` is every thread, archived ones included: there is no archive tab to
 * find them under any more.
 */
export const THREAD_LIST_FILTERS = {
  // No filter at all: ``ThreadFilter`` takes exactly one condition.
  all: undefined,
  pending: { hasPending: true },
} satisfies Record<string, ThreadFilter | undefined>;

export const THREAD_LIST_PAGE_SIZE = 50;
